/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const dealflowRatingCriterionDtoSchema = z.object({
  label: z.optional(z.string()),
  score: z.number().nullish(),
});
